import { render, staticRenderFns } from "./screenDevolucionesFactura.vue?vue&type=template&id=17041b1f&scoped=true"
import script from "./screenDevolucionesFactura.vue?vue&type=script&lang=js"
export * from "./screenDevolucionesFactura.vue?vue&type=script&lang=js"
import style0 from "./screenDevolucionesFactura.vue?vue&type=style&index=0&id=17041b1f&prod&lang=css"
import style1 from "./screenDevolucionesFactura.vue?vue&type=style&index=1&id=17041b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17041b1f",
  null
  
)

export default component.exports